import { IconButton, SwipeableDrawer, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Button } from 'src/Common/ui/button'
import { Checkbox } from 'src/Common/ui/checkbox'
import CustomSearchField from 'src/Common/ui/searchInput'
import { useGovernanceStore } from 'src/Containers/Onboarding/Store/GovernanceStore'
import { useOnboardingStore } from 'src/Containers/Onboarding/Store/OnboardingStore'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { lawTypes } from 'src/Entities/Governance'
import { cn } from 'src/lib/utils'
import { IoIosCloseCircleOutline } from 'react-icons/io'

function SelectRegulation ({ setEditData, regulationListData, setRegulationListData, isSelectRegulation, setIsSelectRegulation, formatCount, handleApplyRegulationList, handleCancelRegulationList }) {
    const [ filteredregulationListData, setFilteredRegulationListData ] = useState()
    const [ regulationListSearchValue, setregulationListSearchValue ] = useState('')
    const getAllRegulations = useGovernanceStore(state => state.getAllRegulationsBasedType)
    const governanceLoading = useGovernanceStore(state => state.governanceLoading)
    const getOrgRegulationLoading = useOnboardingStore(state => state.getOrgRegulationLoading)
    const { allregulations, selectedRegulations } = useGovernanceStore()
    const tempData = selectedRegulations
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const bodyType = queryParams.get('bodyType')
    const [ regListData, setRegListData ] = useState([])
    const loading = (governanceLoading || getOrgRegulationLoading) || false
    useEffect(() => {
        if (regulationListData?.length > 0) {
            setRegListData(JSON.parse(JSON.stringify(regulationListData)))
        }
    }, [regulationListData])
    useEffect(() => {
        if (isSelectRegulation) {
            getAllRegulations(bodyType)
        }
    }, [isSelectRegulation])
    const { t } = useTranslation()
    useEffect(() => {
        setFilteredRegulationListData(
            allregulations?.filter((row) =>
                Object.values(row).some(
                    (value) =>
                        value !== null &&
            value !== undefined &&
            value.toString().toLowerCase().includes(regulationListSearchValue.toLowerCase())
                )
            )
        )
    }, [ regulationListSearchValue, allregulations ])
    const onCheckRegulationList = (item) => {
        const find = regListData.find(obj => obj.id === item.id)
        if (find) {
            setRegListData(regListData?.map((el, i) => {
                if (el?.id === item.id) {
                    return { ...el, status: el.status === 1 || el.status === 2 ? 11 : tempData[i]?.status || 1 }
                } else {
                    return el
                }
            }))
        } else {
            setRegListData([ ...regListData, item ])
        }
    }

    useEffect(() => {
        setEditData((regListData?.map((item) => {
            if (item.status) {
                return {
                    id: item.id,
                    status: item.status
                }
            } else {
                return null
            }
        }))?.filter((item) => item !== null))
    }, [regListData])

    return (
        <div>
            <SwipeableDrawer
                anchor='right'
                open={isSelectRegulation}
                onOpen={() => { }}
                onClose={() => setIsSelectRegulation(false)}
                PaperProps={{ sx: { width: window.innerWidth / 2, overflowX: 'hidden', zIndex: 0 } }}
            >
                <div className='flex flex-col h-full'>
                    <div className='flex justify-between items-center p-5 regulation-drawer-container'>
                        <p className='my-auto regulation-drawer-title text-h2' >{'Select Regulation ' + '(' + lawTypes.find((ele) => +ele.value === +bodyType)?.label + ')'}</p>
                        <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <IconButton onClick={() => handleCancelRegulationList()} aria-label="close" disabled={loading}>
                                <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className='flex p-5 justify-between items-center regulation-drawer-container'>
                        <div>
                            <CustomSearchField setSearch={setregulationListSearchValue} value={regulationListSearchValue} onValueChange={(e) => setregulationListSearchValue(e)} disabled={loading}/>
                        </div>
                        <div>
                            <p className='regulation-count-title text-center'>{'Applicable Regulation'} : <span className='regulation-count'>
                                {formatCount(regListData?.filter(el => el.status === 1)?.length)}</span></p>
                        </div>
                    </div>
                    <div>
                        {filteredregulationListData?.length !== 0
                            ? (filteredregulationListData?.map((item, index) => {
                                return (
                                    <div key={index} className={cn(regulationListData.find((obj) => obj.id === item.id)?.status === 1 ? 'pointer-events-none' : '', 'regulation-list-items px-6 py-2')}>
                                        <Checkbox color={regulationListData.find((obj) => obj.id === item.id)?.status === 1 && 'hsl(var(--grey))'} checked={regListData?.find((obj) => obj.id === item.id)?.status === 1 || regListData?.find((obj) => obj.id === item.id)?.status === 2} onCheckedChange={() => onCheckRegulationList(item)} disabled={loading}/>
                                        {item?.name && <label className='regulation-list-items-label ml-2'>{item?.name}</label>}
                                    </div>
                                )
                            }
                            ))
                            : (<p className='regulation-count-title mt-10 text-center'>{t('No Records Found')}</p>)}
                    </div>

                    <div className='mt-auto mb-3 ml-auto mr-3 flex'>
                        <Button variant='outline' style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }} onClick={handleCancelRegulationList} disabled={loading}>{t('Cancel')}</Button>
                        <Button className='ml-3' onClick={handleApplyRegulationList} disabled={loading}>
                            {loading ? t('Applying...') : t('Apply')}
                        </Button>
                    </div>
                </div>
            </SwipeableDrawer>
        </div>
    )
}

SelectRegulation.propTypes = {
    setEditData: PropTypes.any, regulationListData: PropTypes.any, setRegulationListData: PropTypes.any, isSelectRegulation: PropTypes.any, setIsSelectRegulation: PropTypes.any, formatCount: PropTypes.any, handleApplyRegulationList: PropTypes.any, handleCancelRegulationList: PropTypes.any, loading: PropTypes.bool
}
export default SelectRegulation
